/**
 * @generated SignedSource<<52d7486c96797c8e50f54421042d8221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ColumnHeader_course$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "ColumnHeader_course";
};
export type ColumnHeader_course$key = {
  readonly " $data"?: ColumnHeader_course$data;
  readonly " $fragmentSpreads": FragmentRefs<"ColumnHeader_course">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ColumnHeader_course",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Course",
  "abstractKey": null
};

(node as any).hash = "b5b126d9459f841dbd162a6f340511c0";

export default node;
